import BllVariableTypes from "./../variableTypes";
const portModels = {
  flow: "flow"
};
Object.keys(BllVariableTypes).map(type => (portModels[type] = type));
export default portModels;
